import { LeafletPixiApiSettings, MapRenderer, MapRendererConfig, RendererName } from "./OperationRenderer";
import * as PIXI from "pixi.js";
import { Container } from "pixi.js";
import { LatLngBounds } from "leaflet";
import { hex2number } from "../../../utils/getColorByStatusUnit";
import { ColorEnum } from "../LeafletPixiOverlayService";

const leaflet2pixiBounds = (boundLeaflet: LatLngBounds, settings: LeafletPixiApiSettings) => {
    // let { _northEast, _southWest } = boundLeaflet;

    let { lat: latNE, lng: lngNE } = boundLeaflet.getNorthEast()
    let { lat: latSW, lng: lngSW } = boundLeaflet.getSouthWest()

    // switch (type) {
    // case GlobalLayerEnum.PIXI: {
    let { x: xNE, y: yNE } = settings.project([latNE, lngNE])
    let { x: xSW, y: ySW } = settings.project([latSW, lngSW])
    return { xNE, yNE, xSW, ySW }
    // }
    // case GlobalLayerEnum.LEAFLET: {
    //     return {latNE, lngNE, latSW, lngSW}
    // }
    // }
}
export type ResetLayerEvents = {
    'click': () => void
}

export class ResetLayerRenderer extends MapRenderer<never, never, ResetLayerEvents> {
    container: Container | undefined;
    enabled: boolean = false;
    name: RendererName = RendererName.Reset;

    constructor(config: MapRendererConfig) {
        super(config)
    }

    getZIndex(): number {
        return 5;
    }

    redraw() {
        const graphic = this.container?.getChildByName('reset') as PIXI.Graphics
        if (graphic) this.drawRect(graphic)
    }

    drawRect(dummyGraphic: PIXI.Graphics) {
        let { xNE, yNE, xSW, ySW } = leaflet2pixiBounds(this.map.getBounds(), this.settings)
        let color: any = hex2number(ColorEnum.WHITE)
        dummyGraphic.clear();
        dummyGraphic.beginFill(color, 0.0001);
        dummyGraphic.drawRect(xSW, yNE, xNE - xSW, ySW - yNE);
        dummyGraphic.endFill();
    }

    render() {
        if (!this.container?.getChildByName('reset')) {
            let dummyGraphic = new PIXI.Graphics();
            dummyGraphic.name = 'reset'
            dummyGraphic.interactive = true
            dummyGraphic.buttonMode = true
            this.drawRect(dummyGraphic)
            dummyGraphic.on('click', () => this.emit('click'))
            this.container?.addChild(dummyGraphic)
        }
    }
}